var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfBreadcrumbs',{staticClass:"breadcrumbs",attrs:{"breadcrumbs":_vm.breadcrumbs,"data-testid":"breadcrumbs"},scopedSlots:_vm._u([{key:"current",fn:function(ref){
var breadcrumb = ref.breadcrumb;
return [_c('span',[_vm._v(_vm._s(breadcrumb.text))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }